<template>
	<div class="notFindContainer">
		 <el-col>
		    <el-result icon="warning" >
		      <template slot="title">
				  <span class="title">{{i18n.notFind.title}}</span>
		      </template>
			  <template slot="subTitle">
			  	   <span class="text">{{i18n.notFind.text}}</span>
			  </template>
			  <template slot="extra">
			  	    <el-button class="button_bg" size="medium" @click="back">{{i18n.back}}</el-button>
			  </template>
		    </el-result>
			
		  </el-col>
	</div>
</template>

<script>
	export default {
		components: {},
		computed: {},
		data() {
			return {};
		},
		onLoad() {},
		onUnload() {},
		computed: {
			i18n() {
				return this.$t("lang");
			}
		},
		created() {},
		mounted() {},
		methods: {
			back(){
				this.$router.go(-1)
			}
		}
	};
</script>

<style scoped>
	.notFindContainer{
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.title{
	   font-size: 18px;
	   color: #303133;
	}
	.text{
		font-size: 20px;
		letter-spacing: 3px;
		color: #909399;
	}
	.subTitle{
		padding: 10px;
	}
	/deep/.el-result__icon svg {
		width: 100px;
		height: 100px;
	}
</style>